import { createServerFn } from "@tanstack/react-start";
import { getRequest, setCookie } from "@tanstack/react-start/server";
import type { UserTypes } from "db/types";
import { apiRequest, ApiError } from "@/lib/http";

const SESSION_COOKIE_NAME = "notebook_session";

/**
 * Server function to fetch the currently authenticated user.
 * Forwards the incoming request cookies so the API can read the session cookie.
 */
export const getCurrentUserServer = createServerFn({ method: "GET" }).handler(
  async () => {
    try {
      const request = getRequest();
      return await apiRequest<UserTypes.SerializedUser>("/auth/me", {
        request,
      });
    } catch (error) {
      if (ApiError.isUnauthorized(error) || ApiError.isForbidden(error)) {
        return null;
      }

      console.error("[getCurrentUserServer] Failed to fetch user:", error);
      return null;
    }
  },
);

export const setSessionCookie = createServerFn({ method: "POST" })
  .inputValidator((d: { token: string }) => d)
  .handler(async ({ data }) => {
    const { token } = data;

    if (!token) {
      throw new Error("Token is required");
    }

    const isProduction = process.env.NODE_ENV === "production";
    const cookieDomain = process.env.COOKIE_DOMAIN || undefined;

    setCookie(SESSION_COOKIE_NAME, token, {
      path: "/",
      maxAge: 7 * 24 * 60 * 60,
      httpOnly: true,
      secure: isProduction,
      sameSite: isProduction ? "none" : "lax",
      domain: cookieDomain,
    });

    return { success: true };
  });
